// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__5+H5b","nav__links":"Navbar_nav__links__+24v+","nav__link":"Navbar_nav__link__GBBVo","nav__button":"Navbar_nav__button__t7mt6"};